require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/colored-icons/IconLevel3Colored.tsx
var IconLevel3Colored_exports = {};
__export(IconLevel3Colored_exports, {
  default: () => IconLevel3Colored_default
});
module.exports = __toCommonJS(IconLevel3Colored_exports);

// src/assets/colored-icons/level3.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgLevel3 = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.646 2.20842C16.646 1.32246 17.3642 0.604248 18.2502 0.604248C19.1361 0.604248 19.8543 1.32246 19.8543 2.20841V17.7917C19.8543 18.6777 19.1361 19.3959 18.2502 19.3959C17.3642 19.3959 16.646 18.6777 16.646 17.7917V2.20842ZM18.2502 1.06258C17.6173 1.06258 17.1043 1.57559 17.1043 2.20842V17.7917C17.1043 18.4246 17.6173 18.9376 18.2502 18.9376C18.883 18.9376 19.396 18.4246 19.396 17.7917V2.20841C19.396 1.57559 18.883 1.06258 18.2502 1.06258ZM11.146 6.79175C11.146 5.90579 11.8642 5.18758 12.7502 5.18758C13.6361 5.18758 14.3543 5.90579 14.3543 6.79175V17.7917C14.3543 18.6777 13.6361 19.3959 12.7502 19.3959C11.8642 19.3959 11.146 18.6777 11.146 17.7917V6.79175ZM5.646 11.3751C5.646 10.4891 6.36421 9.77092 7.25016 9.77092C8.13612 9.77092 8.85433 10.4891 8.85433 11.3751V17.7917C8.85433 18.6777 8.13612 19.3959 7.25016 19.3959C6.36421 19.3959 5.646 18.6777 5.646 17.7917V11.3751ZM0.145996 15.9584C0.145996 15.0725 0.864206 14.3542 1.75016 14.3542C2.63612 14.3542 3.35433 15.0725 3.35433 15.9584V17.7917C3.35433 18.6777 2.63612 19.3959 1.75016 19.3959C0.864206 19.3959 0.145996 18.6777 0.145996 17.7917V15.9584Z", fill: "#080B11" }) });
var level3_default = SvgLevel3;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};

// src/Wrappers/IconColoredWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var IconColoredWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper",
      style: getIconBaseCssVariables(props),
      children: props.children
    }
  );
};

// src/icons/colored-icons/IconLevel3Colored.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconLevel3Colored = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconColoredWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(level3_default, {}) });
};
IconLevel3Colored.displayName = "IconLevel3Colored";
var IconLevel3Colored_default = IconLevel3Colored;
